<template>
  <div class="login">
    <login-header />

    <div class="login-main">
      <!-- div class="title">
        {{ $l.appName }}
      </div -->

      <logo />
      <app-title />

      <div class="form" @keyup.enter="login()">
        <div class="phone">
          <font-awesome-icon icon="envelope" class="phone-icon"/>
          <input
            type="text"
            class="input-text"
            v-model="username"
            :placeholder="$l.emailAddress">
        </div>

        <div class="password">
          <font-awesome-icon icon="key" class="password-icon" />
          <input
            type="text"
            class="input-text"
            v-model="password"
            :placeholder="$l.password">
        </div>

        <error-message :errorMessage="errorMessage" />

        <button-white
          :title="$l.login"
          :disabled="username === '' || password === ''"
          :action="login"
          />
      </div>

      <link-register class="register" />

      <language-select />
    </div>
  </div>
</template>

<script>
import LoginHeader from '@/components/Login/Header'
import Logo from '@/components/Login/Logo'
import AppTitle from '@/components/Login/AppTitle'
import LinkRegister from '@/components/Login/LinkRegister'
import LanguageSelect from '@/components/Login/Language'
import ButtonWhite from '@/components/ButtonWhite'
import MixinLocale from '@/components/MixinLocale'
import Parse from 'parse'
import ErrorMessage from '@/components/Error/Message'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    ButtonWhite,
    LoginHeader,
    Logo,
    AppTitle,
    LinkRegister,
    LanguageSelect,
    ErrorMessage
  },

  created: async function () {
    await this.$store.dispatch('app/getApp')
    let locale = this.$store.state.app.locale
    this.$store.dispatch('locale/changeLang', locale)
  },

  data () {
    return {
      username: '',
      password: '',
      errorMessage: null
    }
  },

  methods: {
    login: async function () {
      try {
        await Parse.User.logIn(this.username, this.password)
        this.$router.push({ name: 'home' })
      } catch (error) {
        if (error.code === 101) {
          this.errorMessage = "exceptionInvalidEmailOrPassword"
        } else {
          this.errorMessage = "exceptionInternalServerError"
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  background: #3498db;
}

.login-main {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title {
  text-align: center;
  color: white;
  font-size: 1.6em;
}

.form {
  display: flex;
  align-items: center;
  flex-direction: column;
}

@mixin form {
  width: 80%;
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
}

@mixin input {
  border-bottom: 1px solid white;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 1.2em;
  color: white;
}

.phone {
  @include form;
}

.password {
  @include form;
  margin-bottom: 30px;
}

.phone-icon {
  @include input;
  padding-right: 10px;
}

.password-icon {
  @include input;
  padding-right: 10px;
}

.input-text {
  @include input-reset-design;
  @include input;
  width: 100%;
  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
}

.register {
  margin-top: 40px;
}
</style>
